/** Active sidebar tab, provided from BuilderV2 so the outline can switch it. */

import { inject, provide, ref } from 'vue';
import type { InjectionKey, Ref } from 'vue';

export type SidebarTab = 'blocks' | 'outline';

const TAB_KEY: InjectionKey<Ref<SidebarTab>> = Symbol('builder-v2-sidebar-tab');

export function createSidebarTab(): Ref<SidebarTab> {
    const tab = ref<SidebarTab>('outline');

    provide(TAB_KEY, tab);

    return tab;
}

export function useSidebarTab(): Ref<SidebarTab> {
    const tab = inject(TAB_KEY);

    if (!tab) {
        throw new Error('useSidebarTab must be used inside a BuilderV2 tree');
    }

    return tab;
}
